export default {
  namespaced: false,
  state: {
    isLoggedIn: false
  },
  mutations: {
    SET_LOGGED_IN (state, value) {
      state.isLoggedIn = value
    }
  },
  actions: {
    setLoggedIn ({ commit }, payload) {
      commit('SET_LOGGED_IN', payload)
    }
  }
}
